import React from 'react';
import Layout from '@/Shared/Layout';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import PaginateCount from '@/Shared/PaginateCount';
import Pagination from '@/Shared/Pagination';
import TableHeadSort from '@/Shared/TableHeadSort';
import dayjs from 'dayjs';
import BannersSearchFilter from "@/Pages/Banners/Assets/BannersSearchFilter";
import BannersActionBtns from '@/Pages/Banners/Assets/BannersActionBtns';

const Index = () => {
  const { banners } = usePage().props;

  const {
    data,
    links
  } = banners;

  return (
    <div>
      <div className='mb-3 flex justify-between items-center'>
        <h1 className='text-3xl font-bold'>Banners</h1>
        <InertiaLink
          className='btn-default focus:outline-none'
          href={route('banners.create')}
        >
          <span>Create</span>
          <span className='hidden md:inline'> Banner</span>
        </InertiaLink>
      </div>

      <div className='flex items-center justify-between mb-6'>
        <BannersSearchFilter/>

        <PaginateCount />
      </div>

      <div className='overflow-x-auto bg-white rounded shadow'>
        <table className='w-full table-auto text-sm'>
          <thead>
          <tr className='font-bold text-left'>
            <th className='px-1 pt-5 pb-4 w-1'>_</th>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-1' sortName='id' title='ID' />
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='url' title='Link' />
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='banner_name' title='Banner Name' />
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='showonline' title='Show online' />
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='created_at' title='Date created' />
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='expire_date' title='Expiration date' />

            <th className='px-1 pt-5 pb-4'>Actions</th>
          </tr>
          </thead>
          <tbody>
          {data.map(({
                       id,
                       url,
                       showonline,
                       created_at,
                       banner_name,
                       expire_date,
                       image,
                       mob_image
                     }) => (
            <tr
              key={id}
              className='hover:bg-gray-100 focus-within:bg-gray-100'
            >
              <td className='border-t'>
                <InertiaLink
                  href={route('banners.edit', id)}
                  className='flex items-center px-1 py-4 focus:text-indigo-700 focus:outline-none'
                >
                  >
                </InertiaLink>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='1'
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                  href={route('banners.edit', id)}
                >
                  {id}
                </InertiaLink>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='1'
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                  href={route('banners.edit', id)}
                >
                  {url}
                </InertiaLink>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='1'
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                  href={route('banners.edit', id)}
                >
                  {banner_name}
                </InertiaLink>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='1'
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                  href={route('banners.edit', id)}
                >
                  {showonline ? 'Yes' : 'No'}
                </InertiaLink>
              </td>
              <td className='w-px border-t'>
                <InertiaLink
                  tabIndex='-1'
                  href={route('banners.edit', id)}
                  className='flex items-center px-1 focus:outline-none'
                >
                  {created_at ? dayjs(created_at).format('MM-DD-YYYY HH:MM:ss') : 'Unknown'}
                </InertiaLink>
              </td>
              <td className='w-px border-t'>
                <InertiaLink
                  tabIndex='-1'
                  href={route('banners.edit', id)}
                  className='flex items-center px-1 focus:outline-none'
                >
                  {expire_date ? dayjs(expire_date).format('MM-DD-YYYY HH:MM:ss') : 'Unknown'}
                </InertiaLink>
              </td>
              <td className='w-px border-t'>
                <BannersActionBtns image={image} mob_image={mob_image}/>
              </td>
            </tr>
          ))}
          {data.length === 0 && (
            <tr>
              <td className='px-1 py-4 border-t' colSpan='4'>
                No coupons found.
              </td>
            </tr>
          )}
          </tbody>
        </table>

      </div>
      <Pagination links={links}/>
    </div>
  );
};

Index.layout = page => <Layout title='Banners' children={page} />;

export default Index;
